import React from 'react';
import { Chip } from '@mui/material';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const FileSizeFormatter = ({ row }) => {
  return (
    <>
      { typeof row.file_size === 'number' && row.file_size > 0
          ? row.file_size >= 1024 * 1024
          ? (row.file_size / (1024 * 1024)).toFixed(2) + ' MB'
          : (row.file_size / 1024).toFixed(1) + ' kB'
          : '' }
    </>
  );
};
const FileSizeTypeProvider = props => <DataTypeProvider formatterComponent={FileSizeFormatter} {...props} />

export default FileSizeTypeProvider;
